'use client';

import { useEffect, useState } from 'react';
import { ScratchcardOfTheMonthTemplate } from '../../AreaComponent/templates/ScratchcardOfTheMonthTemplate/ScratchcardOfTheMonthTemplate';

type ScratchcardOfTheMonthSectionProps = {
  namespace: string;
  className?: string;
};

const STATIC_SCRATCHCARDS_OF_THE_MONTH = ['MegaHallowin', 'Oktobeerfest', 'FootballGold', 'HeatWave', 'SummerSpike'] as const;

function pickStaticScratchcardOfTheMonth() {
  return STATIC_SCRATCHCARDS_OF_THE_MONTH[Math.floor(Math.random() * STATIC_SCRATCHCARDS_OF_THE_MONTH.length)]!;
}

function ScratchcardOfTheMonthSection({ namespace, className }: ScratchcardOfTheMonthSectionProps) {
  const [scratchcardName, setScratchcardName] = useState<string>();

  useEffect(() => {
    setScratchcardName(pickStaticScratchcardOfTheMonth());
  }, []);

  if (!scratchcardName) return null;

  return <ScratchcardOfTheMonthTemplate namespace={namespace} scratchcardName={scratchcardName} className={className} />;
}

export { ScratchcardOfTheMonthSection, type ScratchcardOfTheMonthSectionProps };
